<form [formGroup]="toeslagenFg">
    <div formGroupName="aanvrager">
        <div class="row">
            <div class="col-auto">
                <snelstart-ui-text-form-control (change)="saveForm()"
                                                class="custom-input-125"
                                                formControlName="voorletters"
                                                id="voorletters"
                                                label="Voorletter(s)"
                >
                </snelstart-ui-text-form-control>
            </div>
            <div class="col-auto">
                <snelstart-ui-text-form-control (change)="saveForm()"
                                                class="custom-input-100"
                                                formControlName="tussenvoegsels"
                                                id="tussenvoegsels"
                                                label="Tussenvoegsel"
                >
                </snelstart-ui-text-form-control>
            </div>
        </div>
        <div>
            <snelstart-ui-text-form-control (change)="saveForm()"
                                            [required]=true
                                            class="custom-input-250 "
                                            formControlName="achternaam"
                                            id="achternaam"
                                            label="Achternaam"
            >
            </snelstart-ui-text-form-control>
        </div>
    </div>
    <snelstart-ui-bsn-form-control class="custom-input-250 "
                                   formControlName="bsn"
                                   id="bsn"
                                   label="Burgerservicenummer"
    >
    </snelstart-ui-bsn-form-control>
    <snelstart-ui-date-form-control (change)="saveForm()"
                                    class="custom-input-250"
                                    formControlName="geboortedatumAanvrager"
                                    id="geboortedatumAanvrager"
                                    label="Geboortedatum"
                                    placeholder="dd-mm-jjjj"
    >
    </snelstart-ui-date-form-control>
</form>
<form [formGroup]="inkomenFg">
    <div>
        <snelstart-ui-number-form-control (change)="saveForm()"
                                          [required]="true"
                                          [showAllDecimals]="false"
                                          align="right" class="custom-input-250" formControlName="toetsinkomenAangever"
                                          id="toetsinkomenAangever"
                                          label="Toetsinkomen {{this.allowanceEntity.toeslagen?.berekeningsjaar}}"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
    </div>
    <div class="col-auto row g-0">
        <snelstart-ui-number-form-control (change)="saveForm()"
                                          [required]="true"
                                          [showAllDecimals]="false"
                                          align="right" class="custom-input-250"
                                          formControlName="toetsvermogenAangever"
                                          id="toetsvermogenAangever"
                                          label="Toetsvermogen {{this.allowanceEntity.toeslagen?.berekeningsjaar}}"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
        <span class="ps-3 pt-4 row col-auto"
              snelstartUiTooltip="Let op! Het ingevulde vermogen wordt alleen gebruikt voor de berekening van de toeslagen. Het vermogen gaat niet mee in het elektronisch bericht. Het doorgeven van een wijziging voor het vermogen is niet mogelijk via Snelstart Fiscaal. Een wijziging in het vermogen kan de aanvragen wel doorgeven via Mijn Toeslagen van de Belastingdienst."> &#x24D8;</span>
    </div>
    <div>
        <snelstart-ui-select-form-control (change)="saveForm()"
                                          [options]="optionsJaNee"
                                          class="custom-input-250"
                                          formControlName="aangeverHeeftZorgverzekering"
                                          id="aangeverHeeftZorgverzekering"
                                          label="Nederlandse zorgverzekering?"
        >
        </snelstart-ui-select-form-control>
    </div>
    <div>
        <snelstart-ui-select-form-control (change)="saveForm()"
                                          [options]="optionsJaNee"
                                          class="custom-input-250"
                                          formControlName="toeslagPartner"
                                          id="toeslagPartner"
                                          label="Toeslagpartner?"
        >
        </snelstart-ui-select-form-control>
    </div>
</form>
